<template>
  <v-sheet class="operationHistoryTable">
    <resizable-page>
      <template v-slot:header>
        <slot name="header" />
      </template>
      <template v-slot:table="tableProps">
        <v-skeleton-loader
          v-if="loading"
          :loading="loading"
          type="table"
        ></v-skeleton-loader>
        <v-data-table
          :height="tableProps.bodyHeight"
          :headers="computedHeaders"
          :items="tableItems"
          item-key="id"
          hide-default-footer
          disable-pagination
          sort-by="dateTime"
          :class="{ 'operationHistoryTable_tbl-loading': loading }"
          :fixed-header="true"
        >
          <!-- Table body template  -->
          <template v-slot:item="props">
            <tr
              :key="props.item.id"
              :class="
                props.item.date === formattedSelectedDay ? 'selected' : ''
              "
            >
              <td
                class="text-start operationHistoryTable_tbl-date"
                :style="{
                  'max-width': props.headers[0].width + 'px',
                }"
              >
                {{ props.item.date }}
              </td>
              <td class="text-start">
                <span
                  class="operationHistoryTable_tbl-time"
                  :style="{
                    'max-width': props.headers[1].width + 'px',
                  }"
                >
                  {{ props.item.time }}
                </span>
              </td>
              <td class="text-start">
                <tooltip>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      class="operationHistoryTable_tbl-userName text-truncate"
                      style="max-width: 100%"
                      v-on="on"
                    >
                      {{ props.item.userName }}
                    </div>
                  </template>
                  <h2>{{ props.item.userName }}</h2>
                </tooltip>
              </td>
              <td class="text-start">
                <tooltip>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      class="operationHistoryTable_tbl-cameraName text-truncate"
                      style="max-width: 100%"
                      v-on="on"
                    >
                      {{ props.item.cameraName }}
                    </div>
                  </template>
                  <h2>{{ props.item.cameraName }}</h2>
                </tooltip>
              </td>
              <td class="text-start">
                <tooltip>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      class="
                        operationHistoryTable_tbl-historyName
                        text-truncate
                      "
                      style="max-width: 100%"
                      v-on="on"
                    >
                      {{ props.item.historyName }}
                    </div>
                  </template>
                  <h2>{{ props.item.historyName }}</h2>
                </tooltip>
              </td>
            </tr>
          </template>
          <!-- ----------------- -->
          <!-- Infinit scroll -->
          <template v-slot:[`body.append`]>
            <tr class="operationHistoryTable-infinit_scroll">
              <td colspan="7">
                <infinite-loading
                  ref="infinitScroll"
                  spinner="spiral"
                  force-use-infinite-wrapper=".v-data-table__wrapper"
                  @infinite="loadMoreLogs($refs)"
                >
                  <template slot="no-more"><h3></h3></template>
                  <template slot="no-results"> <h3></h3> </template
                ></infinite-loading>
              </td>
            </tr>
          </template>
          <!-- ----------------- -->
          <!-- Table no data -->
          <template v-slot:no-data>
            <tr style="visibility: hidden" />
          </template>
          <!-- ----------------- -->
        </v-data-table>
      </template>
    </resizable-page>
  </v-sheet>
</template>

<script>
import { MimeTypes } from '@/globals/enums';
import InfiniteLoading from 'vue-infinite-loading';
import dayjs from 'dayjs';
import LogHistoryMixin from '@/mixin/logHistoryMixin';
export default {
  name: 'OperationHistoryTable',
  components: {
    InfiniteLoading,
  },
  mixins: [LogHistoryMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    selectedDay: {
      type: Date,
      default: '',
    },
  },

  data: () => ({
    mimeTypes: MimeTypes,
    selectedItems: [],
    clipToolsOpen: false,
    loading: false,
  }),
  computed: {
    computedHeaders() {
      return this.headers;
    },
    tableItems() {
      return this.items;
    },
    formattedSelectedDay() {
      return this.selectedDay
        ? dayjs(this.selectedDay).format('YYYY/MM/DD')
        : null;
    },
  },
  watch: {
    selectedDay() {
      this.$nextTick(() => {
        this.scrollToSelectedDay();
      });
    },
  },
  mounted() {
    this.init();
  },
  created() {
    this.currentCategory = 3;
  },
  methods: {
    async init() {
      try {
        this.loading = true;
        await this.loadMoreLogs(this.$refs);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    scrollToSelectedDay() {
      const selectedDay = this.selectedDay;
      if (!selectedDay) return;
      const selectedDayEl = document.querySelectorAll('tr.selected')[0];

      if (selectedDayEl) {
        const options = {
          container: document.querySelector('.v-data-table__wrapper'),
          duration: 300,
          offset: 0,
        };
        this.$vuetify.goTo(selectedDayEl, options);
      }
    },
  },
};
</script>

<style lang="scss">
.operationHistoryTable {
  &-infinit_scroll {
    text-align: center;
  }
  &.theme--light.v-sheet {
    border-radius: 0;
    box-shadow: none;
    padding: 0;
  }
  &_gap-header {
    height: 26px;
  }
  &_select {
    &-icon {
      width: 34px;
      height: 34px;
      padding: 5px 5px 5px 5px;
      background-color: #0075c2;
      border-radius: 50%;
      display: table-cell;
      vertical-align: middle;
      text-align: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      .icon-check {
        color: #fff;
        font-size: 25px;
        font-weight: 900;
      }
    }
  }
  &_tbl {
    &-loading {
      thead.v-data-table-header {
        visibility: hidden;
      }
    }
    &-img {
      margin: 10px;
    }
    &-date {
      font-size: 14px !important;
      font-weight: 600;
      color: #666;
      text-align: center;
    }
    &-time {
      font-size: 14px !important;
      font-weight: 600;
      color: #666;
      text-align: center;
    }
    &-userName {
      font-size: 14px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #4b4b4b;
    }
    &-cameraName {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      font-family: 'Noto Sans JP', sans-serif;
    }
    &-historyName {
      font-size: 14px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #666;
      font-family: 'Noto Sans JP', sans-serif;
    }
  }
  th {
    vertical-align: bottom;
    min-width: 130px;
    span {
      font-family: 'Noto Sans JP', sans-serif;
      font-size: 12px;
      font-weight: bold;
      color: #4b4b4b;
    }
  }
  td {
    vertical-align: middle;
    max-width: 75px;
    .noThumbnailImage {
      margin: 10px;
    }
  }
  tr.selected {
    background-color: #f4f6fc !important;
    border-color: #f4f6fc !important;
  }
  &_btn {
    margin-right: 5px;
  }
  display: flex;
  flex-direction: column;
  &_subtitle {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
    color: #989898;
  }
  &_title {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 2px;
    color: var(--text-color);
    max-width: 966px;
    @media (min-width: 1280px) {
      width: calc(68vw - 339.77px);
    }
    &_text {
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &_type {
      color: var(--warning-color-lighten1);
      font-size: 12px;
      font-weight: 600;
    }
  }
  &_videos {
    position: relative;
  }
  .v-btn {
    &:not(.v-btn--round).v-size--x-small {
      padding-left: 8px;
      padding-right: 8px;
      &.v-btn--outlined {
        padding-left: 7px;
        padding-right: 7px;
        color: #989898;
        border-color: #989898;
      }
    }
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
  & .v-skeleton-loader__table-heading,
  & .v-skeleton-loader__table-tfoot {
    display: none;
  }
  .v-data-table__wrapper {
    @include scrollBarCustom;
  }
}
</style>
